import { cva } from 'class-variance-authority'

/** Shared appearance for sidebar page rows and document page references. */
export const sidebarMenuButtonVariants = cva(
  'peer/menu-button ring-primary/80 hover:bg-primary/8 hover:text-on-surface active:bg-surface-3 active:text-on-surface data-[active=true]:bg-primary/8 data-[active=true]:text-on-surface data-[state=open]:hover:bg-primary/8 data-[state=open]:hover:text-on-surface flex w-full items-center gap-3 rounded-full p-4 text-left text-sm outline-hidden transition-[width,height,padding] group-has-data-[sidebar=menu-action]/menu-item:pr-8 group-data-[collapsible=icon]:size-14 group-data-[collapsible=icon]:text-[0px] focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:font-medium [&>span:last-child]:truncate [&>svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'hover:bg-primary/8 hover:text-on-surface',
        outline: 'bg-surface-1 hover:bg-primary/8 hover:text-on-surface',
      },
      size: {
        sm: 'p-2 [&>svg]:size-4',
        default: 'text-sm [&>svg]:size-5',
        lg: 'text-sm group-data-[collapsible=icon]:p-3 [&>svg]:size-6',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)
